interface Props {
  height?: number;
  width?: number;
}

const WIXSvg = ({ height = 16, width = 38 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3536_26464)">
        <path
          d="M37.894 0.929688H35.832C35.26 0.929688 34.7254 1.21293 34.4042 1.68661L31.6467 5.75447C31.5732 5.86235 31.4141 5.86235 31.3405 5.75447L28.583 1.68661C28.2624 1.21293 27.7272 0.929688 27.1552 0.929688H25.0933L30.0055 8.17591L25.1204 15.3817H27.1823C27.7543 15.3817 28.2889 15.0985 28.6102 14.6248L31.3405 10.5973C31.4141 10.4895 31.5732 10.4895 31.6467 10.5973L34.3771 14.6248C34.6977 15.0985 35.2329 15.3817 35.8049 15.3817H37.8668L32.9817 8.17591L37.894 0.929688Z"
          fill="black"
        />
        <path
          d="M20.8491 2.40798V15.3817H21.8346C22.6513 15.3817 23.3131 14.72 23.3131 13.9035V0.929688H22.3276C21.5109 0.929688 20.8491 1.59139 20.8491 2.40798Z"
          fill="black"
        />
        <path
          d="M19.0432 0.929688H18.1662C17.2007 0.929688 16.3641 1.59742 16.1501 2.53875L14.1883 11.1632L12.4711 3.11247C12.1534 1.62454 10.6267 0.621133 9.06447 1.05263C8.06937 1.32743 7.33164 2.16813 7.11646 3.17756L5.41677 11.1524L3.45852 2.53936C3.24395 1.59802 2.40736 0.929688 1.44179 0.929688H0.56543L3.8521 15.3811H5.09733C6.22744 15.3811 7.20386 14.5911 7.43952 13.4858L9.54063 3.62593C9.56655 3.50359 9.67624 3.415 9.80101 3.415C9.92577 3.415 10.0355 3.50359 10.0614 3.62593L12.1643 13.4864C12.4 14.5917 13.3764 15.3811 14.5065 15.3811H15.7559L19.0432 0.929688Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3536_26464">
          <rect
            width="37.328"
            height="14.4521"
            fill="white"
            transform="translate(0.56543 0.929688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WIXSvg;
